var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6001 4.80001C1.6001 4.37567 1.76867 3.9687 2.06873 3.66864C2.36878 3.36858 2.77575 3.20001 3.2001 3.20001H12.8001C13.2244 3.20001 13.6314 3.36858 13.9315 3.66864C14.2315 3.9687 14.4001 4.37567 14.4001 4.80001V6.40001C13.9758 6.40001 13.5688 6.56858 13.2687 6.86864C12.9687 7.1687 12.8001 7.57567 12.8001 8.00001C12.8001 8.42436 12.9687 8.83132 13.2687 9.13138C13.5688 9.43144 13.9758 9.60001 14.4001 9.60001V11.2C14.4001 11.6244 14.2315 12.0313 13.9315 12.3314C13.6314 12.6314 13.2244 12.8 12.8001 12.8H3.2001C2.77575 12.8 2.36878 12.6314 2.06873 12.3314C1.76867 12.0313 1.6001 11.6244 1.6001 11.2V9.60001C2.02444 9.60001 2.43141 9.43144 2.73147 9.13138C3.03153 8.83132 3.2001 8.42436 3.2001 8.00001C3.2001 7.57567 3.03153 7.1687 2.73147 6.86864C2.43141 6.56858 2.02444 6.40001 1.6001 6.40001V4.80001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.b923fccda9b1f90e7cb7c54932a3f1f4.svg";
export { ForwardRef as ReactComponent };